<div class="my-container">
  @if (breadcrumbs.length > 0) {
  <div class="my-breadcrumbs">
    <nz-breadcrumb>
      @for (breadcrumb of breadcrumbs; track breadcrumb) {
      <nz-breadcrumb-item>{{ breadcrumb.label }}</nz-breadcrumb-item>
      }
    </nz-breadcrumb>
  </div>
  } @if (titulo) {
  <div class="my-title">{{ titulo }}</div>
  } @if (!esError) {
  <div class="my-body">
    <div class="my-search">
      <form [formGroup]="formBusqueda" class="tw-flex">
        <nz-input-group>
          <input nz-input type="text" formControlName="busqueda" placeholder="Buscar..." />
        </nz-input-group>
        <span nzInputSuffix>
          @if (formBusqueda.controls.busqueda.value) {
          <button type="button" nz-button nzType="link" aria-label="Limpiar búsqueda" class="tw-mr-3" (click)="formBusqueda.controls.busqueda.setValue('')">
            <i class="fal fa-close"></i>
          </button>
          }
          <i class="fal fa-search"></i>
        </span>
      </form>
    </div>
    <div class="my-table">
      <ng-container *ngTemplateOutlet="cabeceraTemplate"></ng-container>
      <nz-table #componenteTabla [nzData]="datos" [nzLoading]="cargando" [nzShowPagination]="false" (nzQueryParams)="onCambiarConfiguracionOrdenacion($event)">
        <thead nzSingleSort>
          <tr>
            @for (item of cabeceraVisible; track trackByHeader($index, item)) {
            <th
              scope="col"
              class="tw-font-semibold"
              [nzSortFn]="item.ordenar"
              [nzColumnKey]="item.key"
              [nzShowSort]="item.ordenar"
              [nzSortOrder]="configuracionPagina.ordenacion.key === item.key ? configuracionPagina.ordenacion.tipo : null"
              [class]="item.clase"
            >
              {{ item.texto }}
            </th>
            }
          </tr>
        </thead>
        <tbody>
          @for (row of componenteTabla.data; track trackByRow($index, row)) {
          <tr nz-tooltip nzTooltipTitle="Doble clic para editar" nzTooltipPlacement="topLeft" class="tw-cursor-pointer" (dblclick)="onDbClick(row)">
            <ng-container *ngTemplateOutlet="filasTemplate; context: { row: row }"></ng-container>
          </tr>
          }
        </tbody>
      </nz-table>
      @if (!cargando) {
      <div class="tw-flex tw-justify-end tw-mt-2">
        @if (configuracionPagina.total > 0) {
        <span>
          <nz-pagination
            #paginationComponent
            (nzPageIndexChange)="onCambiarConfiguracionPagina($event)"
            [nzPageIndex]="configuracionPagina.pagina"
            [nzTotal]="configuracionPagina.total"
          ></nz-pagination>
        </span>
        }
        <button type="button" aria-label="Actualizar" class="tw-ml-2" nz-button [disabled]="cargando" (click)="onRecargarTabla()"><i class="fa-solid fa-arrows-rotate"></i></button>
      </div>
      }
    </div>
  </div>
  } @if (esError) {
  <div class="my-body">
    <nz-alert class="tw-mb-1" nzType="error" [nzMessage]="tituloError" [nzDescription]="descripcionError"></nz-alert>
  </div>
  }
</div>
